<template>
  <div class="container_wrap">
    <div class="content_title">
      {{ catedetailDataArr.ldname }}
    </div>
    <div class="content_date">
      发布日期：{{ catedetailDataArr.create_time | timeFormat }}
    </div>
    <div class="content_container">
      <div class="content_item">
        <div class="content_item_name">姓名</div>
        <div class="content_item_value">
          {{ catedetailDataArr["ldname"] }}
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_name">生日</div>
        <div class="content_item_value">
          {{ catedetailDataArr["age"] }}
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_name">性别</div>
        <div class="content_item_value">
          {{ catedetailDataArr["sex"] }}
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_name">身高</div>
        <div class="content_item_value">
          {{ catedetailDataArr["height"] }} cm
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_name">体重</div>
        <div class="content_item_value">
          {{ catedetailDataArr["weight"] }} kg
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_name">鞋码</div>
        <div class="content_item_value">
          {{ catedetailDataArr["shoesize"] }}
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_name">单位名称</div>
        <div class="content_item_value">
          {{ catedetailDataArr["danwei"] }}
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_name">城市</div>
        <div class="content_item_value">
          {{ catedetailDataArr["province"] }}/
          {{ catedetailDataArr["city"] }}/{{ catedetailDataArr["county"] }}
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_name">可演出时间</div>
        <div class="content_item_value">
          {{ catedetailDataArr["yan_time"] }}
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_name">联系手机</div>
        <div class="content_item_value">
          {{ catedetailDataArr["phone"] }}
        </div>
      </div>
      <!-- <div class="content_item">
        <div class="content_item_name">已取得演员等级</div>
        <div class="content_item_value">
          {{ catedetailDataArr["grade"] }}
        </div>
      </div> -->
      <div class="content_item" v-if="catedetailDataArr['caiyi']">
        <div class="content_item_name">个人才艺</div>
        <div class="content_item_value">
          {{ catedetailDataArr["caiyi"] }}
        </div>
      </div>
      <div class="content_item" v-if="catedetailDataArr['content']">
        <div class="content_item_name">个人经历</div>
        <div class="content_item_value html-data html-data-person" v-html="catedetailDataArr['content']">
        </div>
      </div>
      <div
        class="content_item"
        v-if="catedetailDataArr.pics && catedetailDataArr.pics.length"
      >
        <div class="content_item_name">艺术照</div>
        <div class="content_item_value">
          <viewer :images="catedetailDataArr.pics">
            <img
              :src="item2.url"
              class="content_item_value_img"
              v-for="(item2, index2) in catedetailDataArr.pics"
              :key="index2"
            />
          </viewer>
        </div>
      </div>
      <div
        class="content_item"
        v-if="catedetailDataArr['video'] && catedetailDataArr['video'].length"
      >
        <div class="content_item_name">视频</div>
        <div class="content_item_value">
          <div class="video_area">
            <video
              ref="myVideo"
              preload="auto"
              :src="catedetailDataArr['video'][0].url"
              controls="controls"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//特聘战略专家-爱心大导师   的详情
export default {
  name: "CuteSinglePage",
  data() {
    return {
      catedetailDataArr: [],
    };
  },
  mounted() {
    if (this.$route.name == "CuteSinglePage") {
      this.getCateDetailFun(this.$route.query.id);
    } else {
      this.$message.error("跳转错误");
    }
  },
  methods: {
    getCateDetailFun(id) {
      var that = this;
      that.$api.get(
        "/api/cms/step1Detail",
        {
          id: id,
        },
        (res) => {
          console.log(res);
          //   if (res.data[0].tpl != "CateSinglePage") {
          //     return;
          //   }
          //   this.$message.success(res.data[0].name+"  获取成功");
          that.catedetailDataArr = res.data;
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
  watch: {
    $route: {
      handler() {
        this.getCateDetailFun(this.$route.query.id);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: calc(100vh - 446px);
  overflow: hidden;
}
.content_title {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-size: 22px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: row;
  justify-content: center;
  p:nth-child(2) {
    font-weight: normal;
  }
}
.content_date {
  width: 100%;
  text-align: center;
  font-size: 16px;
  margin-top: 5px;
  color: #9b9b9b;
  margin-bottom: 5px;
}
.content_container {
  margin-bottom: 30px;
  .content_item {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    font-size: 16px;
    overflow: hidden;
    .content_item_name {
      flex: 1;
      overflow: hidden;
    }
    .content_item_value {
      flex: 5;
      overflow: hidden;
      padding-left: 15px;
      box-sizing: border-box;
      .content_item_value_img {
        width: 196px;
        height: 200px;
        object-fit: cover;
        border-radius: 3px;
        display: inline-block;
        margin: 0 8px 8px 0;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .video_area video {
    // max-width: 800px;
    width: 99.2%;
    max-height: 570px;
    object-fit: contain;
  }
}
.html-data-person{
  padding-top: 0;
}
</style>


// WEBPACK FOOTER //
// CuteSinglePage.vue?520d401f